export default __webpack_public_path__ + "static/media/vistasansmed-020415006EmigreWebOnly.3242e034.woff";